const state = {
    projects: [],
    projectId: {},
    tasks: [],
    subtasks: [],
    assignees: [],
    milestones: [],
    loading: false
};

export default state;